import { getNiceDate } from 'libs/utils/date';

export const GetShiftReport = async (StartDate, EndDate) => {
	const url = `/api/cantrackv3/GetShiftReport?payload=`;
	const payload = `{"StartDate":"${StartDate}","EndDate":"${EndDate}"}`;

	const options = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json;charset=UTF-8',
		},
	};
	const response = await fetch(url + payload, options);
	if (response.status !== 200 && response.status !== 304) {
		return '';
	}
	const data = await response.json();
	return data;
};

// const StyledButton = styled.a`
//     &:hover {
//         cursor: pointer;
//     }
// `;

export const getColumns = (startDate, endDate, setSelectedGuard) => {
	const columns = [
		{ field: 'id', headerName: 'ID', width: 70 },
		{
			field: 'name',
			headerName: 'Guard Name',
			width: 130,
			renderCell: (params) => (
				<a href="#!" onClick={() => setSelectedGuard(params.row)}>
					{params.value}
				</a>
			),
		},
	];

	columns.push({
		field: 'totalTime',
		headerName: 'Total Time(mins)',
		type: 'number',
		width: 90,
	});

	columns.push({
		field: 'totalShifts',
		headerName: 'Total Shifts',
		type: 'number',
		width: 90,
	});

	return columns;
};

export const modifyData = (report, startDate, endDate) => {
	const shiftReport = {};
	Object.keys(report).forEach((emp_id) => {
		const tempObj = { shifts: {} };
		const patrols = JSON.parse(report[emp_id]);
		// console.log(patrols);
		patrols.forEach((patrol) => {
			tempObj.ContactName = patrol.ContactName;
			tempObj.Id = patrol.ContactId;
			const patrolDuration =
				new Date(patrol.EndTime) - new Date(patrol.StartTime);
			if (!tempObj.shifts[patrol.WorkDate]) {
				tempObj.shifts[patrol.WorkDate] = patrolDuration;
			} else {
				tempObj.shifts[patrol.WorkDate] += patrolDuration;
			}
		});
		shiftReport[emp_id] = tempObj;
	});
	const tempArr = [];
	Object.keys(shiftReport).forEach((emp, index) => {
		const tempObj = {
			name: shiftReport[emp].ContactName,
			id: index + 1,
			totalTime: 0,
			totalShifts: 0,
		};
		for (
			let currentDate = new Date(startDate);
			currentDate <= new Date(endDate);
			currentDate.setDate(currentDate.getDate() + 1)
		) {
			tempObj[
				`${currentDate.getFullYear()}-${
					currentDate.getMonth() + 1
				}-${currentDate.getDate()}`
			] = 0;
		}
		Object.keys(shiftReport[emp].shifts).forEach((shiftStart) => {
			const currentDate = new Date(shiftStart);
			const shiftDate = `${currentDate.getFullYear()}-${
				currentDate.getMonth() + 1
			}-${currentDate.getDate()}`;
			if (tempObj[shiftDate] === undefined) {
				tempObj[shiftDate] = 1;
			} else {
				// console.log('plus + 1', shiftDate, ': ', tempObj[shiftDate]);
				tempObj[shiftDate] = parseInt(tempObj[shiftDate]) + 1;
			}
			tempObj.totalShifts += 1;
			tempObj.totalTime += Math.floor(
				shiftReport[emp].shifts[shiftStart] / 60000,
			);
		});
		tempArr.push(tempObj);
	});
	const tableData = tempArr;
	return { tableData, shiftReport };
};
